<div class="logo-container">
  <img src="assets/images/logo.png" alt="logo" class="logo">
</div>
<div class="content-container">
  <div>
    <h2>{{title()}}</h2>
    <span>{{description()}}</span>
    <p>{{information()}}</p>
    <ng-content></ng-content>
  </div>
</div>

@if (loading()) {
  <div class="overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
}
